interface IndexDocumentPayload {
    data: any;
    version: string;
    user_id: string;
    created_at: string;
    updated_at: string;
}

export type IndexDocumentAction =
    | { type: "GET_INDEX_DOCUMENT_START" }
    | { type: "GET_INDEX_DOCUMENT_SUCCESS"; payload: IndexDocumentPayload }
    | { type: "GET_INDEX_DOCUMENT_ERROR" }
    | { type: "GET_INDEX_DOCUMENT_NOT_FOUND" }
    | { type: "UPLOAD_INDEX_DOCUMENT_START" }
    | { type: "UPLOAD_INDEX_DOCUMENT_SUCCESS"; payload: IndexDocumentPayload }
    | { type: "UPLOAD_INDEX_DOCUMENT_ERROR" }
    | {
          type: "UPDATE_DOC_LABELS";
          payload: { doc_id: string; labels: Array<string> };
      };

interface IndexDocumentState {
    data: any;
    version: string;
    user_id: string;
    created_at: string;
    updated_at: string;
}

const initialState: IndexDocumentState = {
    data: { labels: {} },
    version: "",
    user_id: "",
    created_at: "",
    updated_at: "",
};

const indexDocument = (state = initialState, action: IndexDocumentAction) => {
    switch (action.type) {
        case "GET_INDEX_DOCUMENT_START":
            return state;
        case "GET_INDEX_DOCUMENT_SUCCESS":
            return action.payload;
        case "GET_INDEX_DOCUMENT_ERROR":
            return state;
        case "GET_INDEX_DOCUMENT_NOT_FOUND":
            return initialState;
        case "UPLOAD_INDEX_DOCUMENT_START":
            return state;
        case "UPLOAD_INDEX_DOCUMENT_SUCCESS":
            return action.payload;
        case "UPLOAD_INDEX_DOCUMENT_ERROR":
            return state;
        default:
            return state;
    }
};

export default indexDocument;
